<template>
  <div class="inquiry-item">
    <Row
      class="enquiryList-item"
      v-if="lists && lists.length > 0"
      v-for="(item, index) in lists"
      :key="index"
      type="flex"
      :gutter="10"
      justify="space-between"
      align="middle"
    >
      <Col span="14">
        <h3>
          {{item.name}}
          <Tag
            class="tag-pink m-l-10"
            :color="enquiryStatus(item.status, item.valid, item.quoting).type"
          >{{enquiryStatus(item.status, item.valid, item.quoting).txt}}</Tag>
        </h3>
        <p class="time">{{item.createTime | date}}</p>
      </Col>
      <Col span="2">
        <span class="time">共{{item.num}}件</span>
      </Col>
      <Col span="8" style="text-align: right;">
        <Button
          v-if="item.cancel"
          style="margin-right:30px;"
          @click="undoHandle(item.projectId)"
        >撤销报价</Button>

        <router-link
          target="_blank"
          :to="`/enquiry-detail/${$route.params.id || item.projectId}/${item.id}?locationId=${$route.query.locationId || item.locationId}`"
        >
          <Button type="primary">查看详情</Button>
        </router-link>

        <Button
          v-if="item.status ===2 && item.valid === 1"
          class="red-btn"
          :loading="orderLoading"
          @click="submitOrders(item)"
          type="primary"
          style="margin-left:30px;"
        >立即下单</Button>
      </Col>
    </Row>
  </div>
</template> 

<script>
import axios from "axios";
import { OLD_BASIC_URL } from "@/constants";
export default {
  data() {
    return {
      OLD_BASIC_URL: OLD_BASIC_URL,
      orderLoading: false
    };
  },
  props: {
    lists: [Array, String],
    default: function() {
      return "";
    }
  },
  methods: {
    enquiryStatus(status, valid, quoting) {
      if (valid == 1) {
        switch (status) {
          case 1:
            if (!quoting) {
              return { type: "red", txt: "待报价" };
            } else {
              return { type: "orange", txt: "报价中" };
            }
            break;
          case 2:
            return { type: "orange", txt: "报价完成" };
            break;
          case 3:
            return { type: "default", txt: "已取消" };
            break;
          default:
            return { type: "red", txt: "报价中" };
        }
      } else {
        return { type: "default", txt: "报价失效" };
      }
    },
    /* 撤销 */
    undoHandle(id) {
      this.$emit("undo", id);
    },

    /* 判断用户是否为认证设计师，并且进行过实名认证 */
    person_auth() {
      if (
        this.$store.state.userInfo.companyAuthStatus <= 1 &&
        this.$store.state.userInfo.realAuthStatus <= 1
      ) {
        this.$Modal.confirm({
          title: "提示",
          okText: "去实名认证",
          cancelText: "返回项目",
          content: "<p>亲，非常抱歉，您还没有进行实名认证，暂时不能下单？</p>",
          onOk: () => {
            window.location.href = `${OLD_BASIC_URL}/my/personal/accountSetting`;
          }
        });
        return false;
      }
      return true;
    },

    /* 提交下单 */
    async submitOrders(item) {
      if (!this.person_auth()) {
        return false;
      }
      this.orderLoading = true;
      /* 请求详情 */
      let projectDetail;
      try {
        projectDetail = await axios.get(
          `/designer_api/projects/${item.projectId}`
        );
      } catch {
        this.orderLoading = false;
      }
      this.orderLoading = false;
      this.$router.push({
        name: "CommitOrders",
        query: {
          projectId: item.projectId,
          enquiryId: item.id,
          locationId: item.locationId,
          projectAdditionalDesc: item.projectAdditionalDesc,
          type: projectDetail.type || 1
        }
      });
    }
  }
};
</script>  

<style lang="scss">
.inquiry-item {
  .enquiryList-item {
    height: 80px;
    padding: 15px 30px;
    background: rgba(250, 250, 250, 1);
    margin-bottom: 15px;
    h3 {
      font-size: 16px;
      font-weight: 500;
      color: rgba(53, 53, 53, 1);
    }
    .status {
      font-size: 14px;
      font-weight: 500;
      color: rgba(208, 2, 27, 1);
    }
    .time {
      font-size: 12px;
      display: inline-block;
      font-weight: 500;
      color: rgba(181, 181, 181, 1);
      margin-top: 5px;
    }
  }
}
</style>